import { DBDef_FindingView } from '@app/advisor-ui-shared';
const conflictResolutionItem_FindingView = {
    dbKey: DBDef_FindingView.dbKey,
    collectionRenderer: () => 'Finding Views',
    renderer: fv => fv.label,
    filterMapper: fv => [fv.label],
};
export const ConflictResolutionItemGroup_AdvisorUI = [
    conflictResolutionItem_FindingView,
];
//# sourceMappingURL=conflict-resolution-items.js.map